import { Club } from "@app/core/club/domain/model/club";
import { Observable } from "rxjs";

export abstract class ClubRepo {
  abstract getClubs(token: string): Observable<Club[]>;
}
